import JSConfetti from 'js-confetti';
import * as Utils from './utils.js';

export default el => {
	const btn = el.querySelector('.js-contact-btn');
	const requiredFields = el.querySelectorAll('[required], .js-required-group');

	const validate = el.parentNode.querySelector('.js-contact-validate');
	const error = el.parentNode.querySelector('.js-contact-error');
	const message = el.parentNode.querySelector('.js-contact-message');

	const canvas = validate.querySelector('canvas');
	const jsConfetti = new JSConfetti({canvas})

	const ajax = () => {
		el.classList.add('loading');

	    const ajax_url = ParamsData.wp_ajax_url;
	    const formData = new FormData(el);
	    const xhr = new XMLHttpRequest();

	    formData.append('action', 'contact');

	    xhr.open('POST', ajax_url, true);
	    xhr.onreadystatechange = () => {
	        if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
	        	el.classList.remove('loading');

	        	const response = JSON.parse(xhr.response);

	        	if (response.status == true) {
	        		message.innerHTML = response.message;
	        		validate.classList.add('active');

	        		window.dataLayer = window.dataLayer || [];
	        		window.dataLayer.push({
	        			'event': 'form_completion'
	        		});

	        		setTimeout(() => {
	        			jsConfetti.addConfetti({
	        				confettiRadius: 4,
	        				confettiNumber: 1000,
	        				confettiColors: [
	        					'#97EDF2',
	        					'#FFCAD4',
	        					'#F9C4A0',
	        					'#FF5331',
	        					'#C00C4E',
	        					'#FFEC00',
	        					// '#00AD5A',
	        					// '#0086D1',
	        					// '#C6FF7D',
	        					// '#FFFFDD',
	        					// '#FFE6D4',
	        				],
	        			})
	        		}, 500)

	        		const datas = getTrackingDatas();
	        		datas.form.step = "validation";

	        		datas.user = {};

	        		const firstname = document.querySelector('input[name="contact-firstname"]');
	        		const lastname = document.querySelector('input[name="contact-lastname"]');
	        		const email = document.querySelector('input[name="contact-email"]');
	        		const phoneCode = document.querySelector('input[name="contact-tel-code"]:checked');
	        		const phone = document.querySelector('input[name="contact-tel"]');

	        		if (firstname && firstname.value.length > 0) datas.user.firstname = firstname.value;
	        		if (lastname && lastname.value.length > 0) datas.user.lastname = lastname.value;
	        		if (email && email.value.length > 0) datas.user.email = email.value;

	        		if (phoneCode && phoneCode.value.length > 0) datas.user.phone = phoneCode.value;

	        		if (phone && phone.value.length > 0) {
	        			if (!datas.user.phone) datas.user.phone = '';

	        			datas.user.phone += phone.value
	        		};

	        		window.dataLayer.push(datas);

	        		return;
	        	}

	        	error.classList.add('active');
	        	error.innerHTML = response.message;
	        }
	    };

	    xhr.send(formData);
	}

	btn.addEventListener('click', () => {
		const error = Utils.validateFields(requiredFields);

		if (!error) {
			ajax();
		}
	})

	document.addEventListener("dialog", function(event) {
		if (event.detail.id == "dialog-contact") {
			const datas = getTrackingDatas();
			window.dataLayer.push(datas);
		}
	});

	const getTrackingDatas = () => {
		const datas = {...TrackingData};
		datas.event = 'form.interact';

		datas.form = {
			name: "contact",
			step: "formulaire",
			interaction: "affichage"
		}

		return datas;
	}
};
